import React, { useState } from 'react';
import OnboardingTemplate from '../OnboardingTemplate';
import Layout from '../../Layout';
import Button from '../../molecules/Button';
import imgSuccess from '../../../assets/images/success-img.svg';
import { SuccessContent } from '../Login/Login.styles';
import { useLocation } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';

const Successful = () => {
  const location = useLocation();
  const signup = location?.state?.signup;

  const successText = signup === 'completed' ? 'Account Created' : 'Password Reset';

  const { getPermissions } = useContextHook(AuthContext, v => ({
    getPermissions: v.getPermissions,
  }));

  async function handleLoggedIn() {
    // Fetch user data and let RouteGuard handle the routing
    await getPermissions();
  }

  return (
    <>
      <Layout showTemplate={false}>
        <OnboardingTemplate>
          <div className="text-content">
            <SuccessContent>
              <div className="img-box">
                <img src={imgSuccess} width="216" alt="success" />
              </div>
              <strong className="title">
                {successText}
                <br /> Successful!
              </strong>
              <Button width="100%" onClick={() => handleLoggedIn()}>
                Go to Dashboard
              </Button>
            </SuccessContent>
          </div>
        </OnboardingTemplate>
      </Layout>
    </>
  );
};

export default Successful;
